var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConstrainedContainer',[_c('p',{staticClass:"mt-20"},[_vm._v(" We're verifying your token ")])])}
var staticRenderFns = []

export { render, staticRenderFns }